module.exports = __webpack_public_path__ + "img/banner3.3c264a21.jpg";